export const generateLinkBuyEth = () => {
  return `https://ramp.network/buy/`;
};
